import React, { useEffect } from 'react';
import './style.scss';

import { Route, HashRouter as Router, Routes } from 'react-router-dom';
import { connect } from 'react-redux';
import { APIProvider } from '@vis.gl/react-google-maps';

import { ROUTES } from './constants';
import { getAiKey, getMapKey, getWeatherKey } from './state/actions';

import {
  About, Community, CreateTrip, TripDetail,
} from './screens';
import MyTrips from './screens/my-trips';

const App = (props) => {
  useEffect(() => {
    props.getAiKey();
    props.getMapKey();
    props.getWeatherKey();
  }, []);

  if (!props.aiKey || !props.mapKey || !props.weatherKey) {
    return <div>Loading...</div>;
  }

  return (
    <APIProvider apiKey={props.mapKey} libraries={['places']}>
      <Router basename="/">
        <Routes>
          <Route index path={ROUTES.ABOUT} element={<About />} />
          <Route path={ROUTES.CREATE_TRIP} element={<CreateTrip />} />
          <Route path={ROUTES.MY_TRIPS} element={<MyTrips />} />
          <Route path={ROUTES.COMMUNITY} element={<Community />} />
          <Route path="/:tripId" element={<TripDetail />} />
        </Routes>
      </Router>
    </APIProvider>
  );
};

const mapStateToProps = (state) => ({
  aiKey: state.data.aiKey,
  mapKey: state.data.mapKey,
  weatherKey: state.data.weatherKey,
});

const mapDispatchToProps = (dispatch) => ({
  getAiKey: () => dispatch(getAiKey()),
  getMapKey: () => dispatch(getMapKey()),
  getWeatherKey: () => dispatch(getWeatherKey()),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
